import { useEffect, useRef, useState } from "react";
import EventScheduleCalender from "./components/calender";
import {
  EventScheduleWrapper,
  EventScheduleHeader,
  EventScheduleContentWrapper,
  EventScheduleTabWrapper,
} from "./style";
import { insetState } from "../../../recoil/inset";
import { useRecoilValue } from "recoil";
import EventScheduleDateFilter from "./components/date-filter";
import { Overlay } from "../OddsCalc/styles";
import EventScheduleList from "./components/schedule-list";
import { useSchedule } from "./hook/useSchedule";
import EventComponent from "./components/event";
import Header from "../../../components/header";

const EventSchedule = () => {
  const inset = useRecoilValue(insetState);
  const bannerRef = useRef<HTMLDivElement>(null);
  const [calenderOpen, setCalenderOpen] = useState<boolean>(false);
  const [tab, setTab] = useState<"EVENT" | "SCHEDULE">("SCHEDULE");
  const [showHeader, setShowHeader] = useState(true);
  const {
    list,
    countList,
    renderDays,
    attendeeList,
    pubList,
    selectedAttendee,
    selectedPub,
    setSelectedAttendee,
    setSelectedPub,
    setYear,
    setMonth,
    date,
    setDate,
    getCountList,
    year,
    month,
  } = useSchedule();

  useEffect(() => {
    if (date) {
      const [year, month, _] = date.split("-");
      setYear(+year);
      setMonth(+month);
    }
  }, [date]);

  // header 투명 여부
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      },
      {
        threshold: 0.1, // 10% 보일 때 트리거
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [bannerRef.current]);

  return (
    <EventScheduleWrapper isApp={inset}>
      {calenderOpen && (
        <EventScheduleCalender
          countList={countList}
          renderDays={renderDays}
          getCountList={getCountList}
          date={date}
          setDate={setDate}
          setCalenderOpen={setCalenderOpen}
          year={year}
          month={month}
        />
      )}
      <Header title="" show={showHeader} />
      <EventScheduleHeader isApp={inset} ref={bannerRef}>
        <div className="banner">
          <img
            src="https://dfesoodpx4jgd.cloudfront.net/events/event_banner_9.png"
            alt="banner"
          />
        </div>
        <div className="title">
          러너러너
          <br />
          공식 엠버서더
          <br />
          <span>홍진호 / 케이시 / 윤슬 / 소라 / 미래 / 예린</span>
        </div>
      </EventScheduleHeader>
      <EventScheduleContentWrapper isApp={inset}>
        {tab === "SCHEDULE" ? (
          <>
            <EventScheduleDateFilter
              renderDays={renderDays}
              countList={countList}
              date={date}
              setDate={setDate}
              selectedAttendee={selectedAttendee}
              selectedPub={selectedPub}
              setSelectedAttendee={setSelectedAttendee}
              setSelectedPub={setSelectedPub}
              setYear={setYear}
              setMonth={setMonth}
              attendeeList={attendeeList}
              pubList={pubList}
            />
            <EventScheduleList list={list} setCalenderOpen={setCalenderOpen} />
          </>
        ) : (
          <EventComponent />
        )}
      </EventScheduleContentWrapper>
      {calenderOpen && <Overlay />}
    </EventScheduleWrapper>
  );
};

export default EventSchedule;
